import Icon from '../components/Icon.vue'

Icon.register({
  'audio-description': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M162.9 238.7L171.7 269.4H146.1L155.2 238.7C156.5 234.3 157.8 228.7 159.1 223.5 160.3 228.7 161.6 234.3 162.9 238.7zM329.4 206.6H314.9V305.4H329.4C359.2 305.4 375.6 287.7 375.6 255.6 375.6 223.4 358.1 206.6 329.4 206.6zM512 112V400C512 426.5 490.5 448 464 448H48C21.5 448 0 426.5 0 400V112C0 85.5 21.5 64 48 64H464C490.5 64 512 85.5 512 112zM245.5 336.1L188.4 168.1A12-12 0 0 1 177 160H141.1A12-12 0 0 1 129.7 168.1L72.6 336.1C70 343.9 75.8 352 84 352H113.1A12-12 0 0 1 124.7 343.3L133.3 313.4H184.6L193.4 343.4A12-12 0 0 1 204.9 352H234.1C242.3 352 248.1 343.9 245.5 336.1zM430.2 255.6C430.2 196.6 392.2 160 331.2 160H273.8C267.2 160 261.8 165.4 261.8 172V340C261.8 346.6 267.2 352 273.8 352H331.2C392.2 352 430.2 315.1 430.2 255.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/audio-description.js
// module id = 8Oal
// module chunks = 144